module.exports = __webpack_public_path__ + "static/media/sample-avatar@3x.6fe6c60f.jpg";